var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-checkbox"},_vm._l((_vm.values),function(item,index){return _c('div',{key:index,staticClass:"checkbox d-flex align-items-center",class:{ blocked: item.disabled },on:{"click":function($event){return _vm.toggle(index)}}},[_c('i',{class:{
        'icon-square-o text-secondary': !item.value,
        'icon-check-square text-primary': item.value
      }}),_c('span',[_vm._v(_vm._s(item.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }